<template>
  <div
    class="the-preloader"
    :style="{
      display: displaying,
      opacity
    }"
  >
    <svg class="flag" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" viewBox="0 0 256 3">
      <!-- <desc>Flag of Germany</desc> -->
      <rect class="starting-color" width="256" height="3" y="0" x="0" fill="#000"/>
      <!-- <rect id="gold_stripe" width="2" height="3" y="0" x="0" fill="#FFCE00"/> -->
      <rect id="replacing-color" :width="percentage" height="3" y="0" x="0" fill="#FFF"/>
    </svg>
  </div>
</template>

<script>
import pageLoadAnimationBus from '../pageLoadAnimationBus'
export default {
  name: 'thePreloader',
  data () {
    return {
      percent: 1,
      opacity: 0,
      display: false
    }
  },
  computed: {
    percentage () {
      const x = 27
      const y = 115
      return (this.percent * x) + y
    // this.$store.dispatch('animations/onFirstLoad')
    },
    displaying () { return (this.display) ? 'block' : 'none' }
  },
  mounted () {
    pageLoadAnimationBus.registerComponent('thePreloader', this)
  }
}
</script>

<style lang="scss" scoped>
.the-preloader{
  width: 100vw;
  height: 100vh; /* Fallback for browsers that do not support Custom Properties */
  height: calc(var(--vh, 1vh) * 100);
  position: fixed;
  top: 0;
  left: 0;
  background-color: #D8C97A;
  background-repeat: no-repeat;
  z-index: 1000000000;
  display: flex;
  justify-content: center;
  align-items: center;
  .flag{
    width: 100vw;
    height: 100vh; /* Fallback for browsers that do not support Custom Properties */
    // height: calc(var(--vh, 1vh) * 100);
    mask-image: url('~@/assets/sec.svg');
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: 6%;
    -webkit-mask-image: url('~@/assets/sec.svg');
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    -webkit-mask-size: 6%;
  }
}
</style>
